<div *ngIf="fieldset; else elseTpl">
    <fieldset>
        <legend class="fieldset-legend" *ngIf="fieldsetLegendKey" [i18n]="fieldsetLegendKey"></legend>
        <ng-container *ngTemplateOutlet="elseTpl"></ng-container>
    </fieldset>
</div>
<ng-template #elseTpl>
    <div class="helper-message" *ngIf="helperKey" [i18n]="helperKey"></div>
    <div class="data-filters-group"
         [ngClass]="{'marginBottom': marginBottom, 'space-between': spaceBetween, 'space-auto': spaceAuto, 'use-available-width': useAvailableWidth, 'direction-column': flexDirection === 'column' }">
        <span class="group-label" *ngIf="labelKey" [i18n]="labelKey"></span>
        <ng-content select="app-data-filter-group, app-data-filter-multi-string-input, app-data-filter-input, app-data-filter-select, app-data-filter-date, app-data-filter-radio,
     app-data-filter-checkbox, app-data-filter-autocomplete, app-data-filter-form-autocomplete, app-data-filter-switch, app-data-filter-message, app-data-buttons, app-collapsible, ng-select"></ng-content>
    </div>
</ng-template>
